import { PathUtils } from "../../Engine/Core/PathUtils/PathUtils";
import { IViewModelContainer } from "../../Engine/Core/Store/FullFormState";
import { reject } from "../../../../Common/TypingUtils";
import { AbsoluteModelPath, createAbsoluteFromTokens, PathTokens } from "../../../../Common/ModelPath/ModelPath";

import { currentViewModelSelect } from "./ViewModelSelect";

export function getInstancesAfterAdd(
    instances: readonly string[],
    newInstance: string | undefined,
    instanceIndex: number
): string[] {
    if (!newInstance) {
        return [...instances];
    }

    return [...instances.slice(0, instanceIndex), newInstance, ...instances.slice(instanceIndex, instances.length)];
}

export function getInstancesAfterRemove(instances: readonly string[], instancesToRemove: readonly string[]): string[] {
    const instancesToRemoveSet = new Set(instancesToRemove);
    return instances.filter(i => !instancesToRemoveSet.has(i));
}

export function resolveMask(mask: string, instance: string): string {
    const pathTokens = PathUtils.split(mask);
    const tokenWithWildcardIndex = pathTokens.findIndex(ch => ch === "*" || ch.startsWith("*."));
    if (tokenWithWildcardIndex === -1) {
        return mask;
    }
    const parentPathTokens = pathTokens.slice(0, tokenWithWildcardIndex);
    const childPathTokens = pathTokens.slice(tokenWithWildcardIndex + 1);
    const tokenWithWildcard = pathTokens[tokenWithWildcardIndex] ?? reject();
    return [...parentPathTokens, tokenWithWildcard.replace("*", instance), ...childPathTokens].join("/");
}

export function getMultipleValues(
    viewModel: IViewModelContainer,
    dataPath: AbsoluteModelPath,
    fieldName: string = "value"
): string[] {
    const splittedPath = dataPath.getPathPartsAsArray();
    const multipleSymbolIndex = splittedPath.findIndex(ch => PathTokens.isMultiToken(ch));

    if (multipleSymbolIndex !== -1) {
        const splittedParentPath = splittedPath.slice(0, multipleSymbolIndex);
        const children = currentViewModelSelect.children(viewModel, splittedParentPath.join("/"));
        const splittedChildPath = splittedPath.slice(multipleSymbolIndex + 1);
        const resolvedPaths = children.map(child =>
            createAbsoluteFromTokens([...splittedParentPath, child, ...splittedChildPath])
        );
        const multipleData = resolvedPaths.map(resolvedPath => getMultipleValues(viewModel, resolvedPath, fieldName));

        return multipleData.flat();
    }

    const modelValue = currentViewModelSelect.customFieldValueOrUndefined(viewModel, dataPath, fieldName) ?? "";

    return [modelValue];
}

export function findFreeInstanceNumber(instances: Iterable<string>): string {
    const sortedInstances = new Set(instances);

    for (let instanceIndex = 0; instanceIndex < sortedInstances.size; instanceIndex++) {
        if (!sortedInstances.has(instanceIndex.toString())) {
            return instanceIndex.toString();
        }
    }
    return sortedInstances.size.toString();
}
